import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {SenatorQualityGateService, SenatorService} from '../../../../../api/services';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SenatorCompany} from '../../../../../api/models/senator-company';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ShowTradeByIdComponent} from '../show-trade-by-id/show-trade-by-id.component';
import {SenatorAssetType} from '../../../../../api/models/senator-asset-type';
import {SenatorIssuerMappingsFilterModel} from '../../../../../api/models/senator-issuer-mappings-filter-model';
import {SenatorQualityGateType} from '../../../../../api/models/senator-quality-gate-type';
import {SenatorQualityGateModel} from '../../../../../api/models/senator-quality-gate-model';
import GetReplaceableAssetNamesParams = SenatorQualityGateService.GetReplaceableAssetNamesParams;
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AssetTypeStat} from '../../../../../api/models/asset-type-stat';
import {SelectionModel} from '@angular/cdk/collections';
import {SenatorSuspiciousIssuerTrade} from '../../../../../api/models/senator-suspicious-issuer-trade';
import {SenatorSuspiciousIssuerRecordUpdate} from '../../../../../api/models/senator-suspicious-issuer-record-update';
import {SenatorOldCompanyName} from '../../../../../api/models/senator-old-company-name';

@Component({
  selector: 'app-suspicious-issuer-trade',
  templateUrl: './suspicious-issuer-trade.component.html',
  styleUrls: ['./suspicious-issuer-trade.component.scss']
})
export class SuspiciousIssuerTradeComponent implements OnInit, AfterViewInit {

  twoIQAssetsList: SenatorCompany[] = [];
  issuerIndex: number;

  addOldCompanyForm: FormGroup;

  @ViewChild(ShowTradeByIdComponent)
  showTradeById: ShowTradeByIdComponent;

  // mat table vars
  displayedColumns: string[] = ['select', 'count', 'trade', 'x2iq_asset_name', 'gvkey', 'type', 'assetType', 'assetSubCategory', 'tradeIndex', 'transactionType', 'transactionDate'];
  issuerTableDataSource: MatTableDataSource<SenatorSuspiciousIssuerTrade>;

  pageSize: number;
  pageNumber: number;
  pageSizeOptions: number[] = [10, 20, 50];
  pageEvent: PageEvent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  issuerSearch: any;
  lastPageNumber: number;

  loadingData: boolean;
  assetNamesLoading: boolean;
  isToBeMuted = false;
  selectedShareType = [] as string[];

  transactionTypes = ['Exchange', 'Purchase', 'Received', 'Sale', 'Sale (Full)', 'Sale (Partial)'];

  assetTypes = SenatorAssetType.values().map(t => t.toString()).sort();
  typedSearchCriteria = '';
  selectedFilterAssetType = '';
  selectedNewIssuer;
  assetTypeStats = [] as AssetTypeStat[];

  currencyCodes: string[] = [
    "USD",
    "CAD",
    "EUR",
    "AED",
    "AFN",
    "ALL",
    "AMD",
    "ARS",
    "AUD",
    "AZN",
    "BAM",
    "BDT",
    "BGN",
    "BHD",
    "BIF",
    "BND",
    "BOB",
    "BRL",
    "BWP",
    "BYN",
    "BZD",
    "CDF",
    "CHF",
    "CLP",
    "CNY",
    "COP",
    "CRC",
    "CVE",
    "CZK",
    "DJF",
    "DKK",
    "DOP",
    "DZD",
    "EEK",
    "EGP",
    "ERN",
    "ETB",
    "GBP",
    "GEL",
    "GHS",
    "GNF",
    "GTQ",
    "HKD",
    "HNL",
    "HRK",
    "HUF",
    "IDR",
    "ILS",
    "INR",
    "IQD",
    "IRR",
    "ISK",
    "JMD",
    "JOD",
    "JPY",
    "KES",
    "KHR",
    "KMF",
    "KRW",
    "KWD",
    "KZT",
    "LBP",
    "LKR",
    "LTL",
    "LVL",
    "LYD",
    "MAD",
    "MDL",
    "MGA",
    "MKD",
    "MMK",
    "MOP",
    "MUR",
    "MXN",
    "MYR",
    "MZN",
    "NAD",
    "NGN",
    "NIO",
    "NOK",
    "NPR",
    "NZD",
    "OMR",
    "PAB",
    "PEN",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RSD",
    "RUB",
    "RWF",
    "SAR",
    "SDG",
    "SEK",
    "SGD",
    "SOS",
    "SYP",
    "THB",
    "TND",
    "TOP",
    "TRY",
    "TTD",
    "TWD",
    "TZS",
    "UAH",
    "UGX",
    "UYU",
    "UZS",
    "VEF",
    "VND",
    "XAF",
    "XOF",
    "YER",
    "ZAR",
    "ZMK",
    "ZWL"];

  selection = new SelectionModel<SenatorSuspiciousIssuerTrade>(true, []);

  loading = false;

  constructor(private qualityGateService: SenatorQualityGateService,
              private _senatorService: SenatorService, private senatorService: SenatorService,
              public snackBar: MatSnackBar, private _fb: FormBuilder, private changeDetectorRefs: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.initVars();
    this.issuerTableDataSource = new MatTableDataSource<SenatorSuspiciousIssuerTrade>();
    this.getAllSuspiciousIssuerTrades();
  }

  ngAfterViewInit() {
    if (this.issuerTableDataSource) {
      this.issuerTableDataSource.paginator = this.paginator;
      this.issuerTableDataSource.sort = this.sort;
    }
  }

  initVars() {
    this.pageSize = 10;
    this.pageNumber = 1;
    this.lastPageNumber = 0;
    this.createAddOldCompanyForm();
  }

  createAddOldCompanyForm() {
    this.addOldCompanyForm = this._fb.group({
      'name': [null, Validators.required],
      'gvkey': [null, Validators.required]
    });
  }

  getAllSuspiciousIssuerTrades() {
   /* this.loadingData = true;

    const filterModel: SenatorIssuerMappingsFilterModel = {
      qualityGateType: SenatorQualityGateType.SUSPICIOUS_ISSUER_TRADES,
      processedType: 'ALL'
    };

    const params: GetReplaceableAssetNamesParams = {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      issuerMappingsFilterModel: filterModel
    };
    console.log('params: ', params);
    this.loading = true;
    this.qualityGateService.getReplaceableAssetNames(params).subscribe(
      (res: SenatorQualityGateModel) => {
        console.log('all suspicious issuer records:', res.rowsForSuspiciousIssuerTrade);
        this.issuerTableDataSource = new MatTableDataSource<SenatorSuspiciousIssuerTrade>(res.rowsForSuspiciousIssuerTrade);
      },
      error => {
        this.loadingData = false;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.loadingData = false;
        this.issuerTableDataSource.paginator = this.paginator;

      }
    );*/
  }

  openSnackBar(message: string, action: string
  ) {
    this.snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  onPaginateChange(event: PageEvent) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    // this.getAllSelectedSecurityTypeSpecificIssuerTrades();
    // console.log('onPaginateChange: event', event);
  }

  openTrade(trade_id: number, type: string) {
    this.showTradeById.loadDialog(trade_id, type == 'R' ? 'Representative' : 'Senator');
  }

  tradeClosedEvent() {
    this.getAllSuspiciousIssuerTrades();
  }

  searchAssetNames(companyName: string) {
    // this.activeRow = trade;
    this.assetNamesLoading = true;
    // console.log('Key up event', name);
    this._senatorService.getSenatorAssetNames(companyName).subscribe((res: SenatorCompany[]) => {
      this.twoIQAssetsList = res;
    }, (err) => {
      this.assetNamesLoading = false;
      // console.log('file update Error', err);
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong! please enter a valid company name.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {
      this.assetNamesLoading = false;
      if (this.twoIQAssetsList.length === 0) {

        this.snackBar.open('No Company found with this name', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }
    });
  }

  applyAssetTypeFilter() {
    console.log('filter selection: ', this.selectedFilterAssetType);

    let filterValue = this.selectedFilterAssetType.trim();
    filterValue = filterValue.toLowerCase();
    this.issuerTableDataSource.filter = filterValue;
    this.selection.clear();
    this.typedSearchCriteria = undefined;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();

    this.issuerTableDataSource.filter = filterValue;
    this.selection.clear();
    this.selectedFilterAssetType = undefined;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.issuerTableDataSource.filteredData.forEach(row => this.selection.select(row));
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.issuerTableDataSource.filteredData.length;
    return numSelected === numRows;
  }

  onSaveClick() {
    console.log('selections ', this.selection);
    console.log('status', this.selection.selected.length == 0);

    const newMute = this.isToBeMuted;
    console.log('muted: ', newMute);

    let newIssuerName = null;
    let newGvkey = null;

    if (this.selectedNewIssuer != null) {
      newIssuerName = this.selectedNewIssuer.name;
      newGvkey = this.selectedNewIssuer.gvkey;
    }

    const params: SenatorSuspiciousIssuerRecordUpdate = {
      senatorSuspiciousIssuerTrade: this.selection.selected,
      muted: newMute,
      x2iq_asset_name: newIssuerName,
      gvkey: newGvkey
    }
    console.log('params: ', params);

    this.qualityGateService.updateAllSuspiciousIssuerRecord(params).subscribe((res: any) => {
      console.log('save multiple res', res);
      this.clearSelections();
      this.openSnackBar('Record details has been updated successfully!', 'Close');
      this.getAllSuspiciousIssuerTrades();

    }, (err) => {
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong!.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {

    });
  }

  mapCompanyAsSelected(company) {
    this.selectedNewIssuer = company;
    console.log('selected company as :', this.selectedNewIssuer);
  }

  clearIssuerSelection() {
    this.selectedNewIssuer = undefined;
    console.log('selected company as :', this.selectedNewIssuer);
  }

  clearSelections() {
    this.selection.clear();
    this.selectedNewIssuer = undefined;
    this.isToBeMuted = false;
    this.selectedFilterAssetType = undefined;
    this.typedSearchCriteria = undefined;
  }

  clearAddOldCompanyForm() {
    this.addOldCompanyForm.reset();
  }

  addOldCompanyName() {
    const newOldCompanyName = this.addOldCompanyForm.get('name').value;
    const newGvkey = this.addOldCompanyForm.get('gvkey').value;
    console.log('new old company name', newOldCompanyName);
    console.log('new gvkey', newGvkey);

    const senatorOldCompany: SenatorOldCompanyName = {
      name: newOldCompanyName,
      gvkey: newGvkey
    } as SenatorOldCompanyName;

    this.qualityGateService.addOldCompanyName(senatorOldCompany).subscribe((res: any) => {
      console.log('save old company res', res);
      this.clearAddOldCompanyForm();
      this.openSnackBar('Old Company Added Successfully! You will see relevant trade records in the feed once the daily maintenance job reruns', 'Close');

    }, (err) => {
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong!.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {

    });
  }

  checkOldCompanyNameFormValidity() {
    return this.addOldCompanyForm.invalid;
  }

}
